package com.trevorwiebe.timesheet.core.presentation.common

import androidx.compose.runtime.Composable
import kotlinx.browser.window

@Composable
actual fun rememberTextSharer(): (text: String) -> Unit {
    return { text ->
        val navigator = window.navigator.asDynamic()
        if (navigator.share != null) {
            val data = js("({})")
            data.text = text
            // Rejection (e.g. the user dismissing the share sheet) is expected — swallow it.
            navigator.share(data).catch { }
        } else {
            window.navigator.clipboard.writeText(text)
            window.alert("Copied to clipboard")
        }
    }
}
